import React from 'react';
import '../../App.css';
import Cards from '../Cards';
import Footer from '../Footer';
import HeroSection from '../HeroSection';
import Contact from '../Contact';

function Home() {
  return (
    <>
      <HeroSection />
      <Cards />
      <Contact/>
      <Footer />
    </>
  );
}

export default Home;
